import React from 'react';

interface CardProps {
  children: React.ReactNode;
  title?: string;
  className?: string;
  variant?: 'default' | 'elevated' | 'bordered';
}

export const Card: React.FC<CardProps> = ({
  children,
  title,
  className = '',
  variant = 'default',
}): React.ReactElement => {
  const baseStyles: React.CSSProperties = {
    backgroundColor: '#16162a',
    borderRadius: '12px',
    overflow: 'hidden',
  };

  const variantStyles: Record<string, React.CSSProperties> = {
    default: {
      border: '1px solid rgba(212, 175, 55, 0.2)',
    },
    elevated: {
      border: '1px solid rgba(212, 175, 55, 0.2)',
      boxShadow: '0 20px 40px rgba(0, 0, 0, 0.4)',
    },
    bordered: {
      border: '2px solid rgba(212, 175, 55, 0.4)',
    },
  };

  return (
    <div style={{ ...baseStyles, ...variantStyles[variant] }} className={className}>
      {title && (
        <div
          style={{
            padding: '16px 24px',
            borderBottom: '1px solid rgba(212, 175, 55, 0.2)',
          }}
        >
          <h2
            style={{
              fontSize: '1.25rem',
              fontWeight: 700,
              color: '#d4af37',
              fontFamily: 'Cinzel, serif',
              margin: 0,
            }}
          >
            {title}
          </h2>
        </div>
      )}
      <div style={{ padding: '24px' }}>{children}</div>
    </div>
  );
};
